import { ReactComponent as YourStoriesLogo } from '../assets/YourStoriesLogo.svg'

function Logo() {
  return <YourStoriesLogo width='200px' height='60px' />;
}

export default Logo;